<div *ngIf="zeitslotBuchung">
    <h1
        >Anfrage: {{ zeitslotBuchung.datum_uhrzeit_von | date: "dd.MM.YYYY" }} -
        <span *ngIf="landwirt">{{ landwirt.bezeichnung }}</span></h1
    >

    <mat-tab-group>
        <mat-tab label="Buchungsdaten">
            <div class="container">
                <div class="detail-block">
                    <h2>Daten</h2>
                    <div class="detail-block-content">
                        <span class="field-title">Datum: </span>
                        <div>{{ zeitslotBuchung.datum_uhrzeit_von | date: "dd.MM.YYYY" }}</div>
                        <span class="field-title">Uhrzeit: </span>
                        <div
                            >{{ zeitslotBuchung.datum_uhrzeit_von | date: "HH:mm" }} -
                            {{ zeitslotBuchung.datum_uhrzeit_bis | date: "HH:mm" }}
                            Uhr</div
                        >
                        <span class="field-title">Tierzahl: </span>
                        <div>{{ zeitslotBuchung.tierzahl }}</div>
                    </div>
                </div>
                <div class="grid grid-2-columns gap-10">
                    <div class="detail-block">
                        <h2>Viehhändler</h2>
                        <div class="detail-block-content">
                            <span class="field-title">Name: </span>
                            <div>{{ zeitslotBuchung?.haendler_bezeichnung }}</div>
                            <span class="field-title">VVVO: </span>
                            <div>{{ zeitslotBuchung?.haendler_vvvo }}</div>
                            <span class="field-title">Telefon: </span>
                            <div>{{ zeitslotBuchung?.haendler_telefon_1 }}</div>
                            <span class="field-title">Mobil: </span>
                            <div>{{ zeitslotBuchung?.haendler_mobil_1 }}</div>
                            <span class="field-title">Fax: </span>
                            <div>{{ zeitslotBuchung?.haendler_fax }}</div>
                            <span class="field-title">e-Mail: </span>
                            <div>{{ zeitslotBuchung?.haendler_email }}</div>
                            <span class="field-title">Adresse:</span>
                            <div>
                                <div>{{ zeitslotBuchung?.haendler_strasse }}</div>
                                <div>{{ zeitslotBuchung?.haendler_plz }} {{ zeitslotBuchung?.haendler_ort }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="detail-block">
                        <h2>Schlachthof</h2>
                        <div class="detail-block-content">
                            <span class="field-title">Name: </span>
                            <div>{{ zeitslotBuchung?.schlachthof_bezeichnung }}</div>
                            <span class="field-title">VVVO: </span>
                            <div>{{ zeitslotBuchung?.schlachthof_vvvo }}</div>
                            <span class="field-title">Telefon: </span>
                            <div>{{ zeitslotBuchung?.schlachthof_telefon_1 }}</div>
                            <span class="field-title">Mobil: </span>
                            <div>{{ zeitslotBuchung?.schlachthof_mobil_1 }}</div>
                            <span class="field-title">Fax: </span>
                            <div>{{ zeitslotBuchung?.schlachthof_fax }}</div>
                            <span class="field-title">e-Mail: </span>
                            <div>{{ zeitslotBuchung?.schlachthof_email }}</div>
                            <span class="field-title">Adresse:</span>
                            <div>
                                <div>{{ zeitslotBuchung?.schlachthof_strasse }}</div>
                                <div>{{ zeitslotBuchung?.schlachthof_plz }} {{ zeitslotBuchung?.schlachthof_ort }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="detail-block" *ngIf="zeitslotBuchung?.kunde_id_spediteur">
                        <h2>Spediteur</h2>
                        <div class="detail-block-content">
                            <span class="field-title">Name: </span>
                            <div>{{ zeitslotBuchung?.spediteur_bezeichnung }}</div>
                            <span class="field-title">VVVO: </span>
                            <div>{{ zeitslotBuchung?.spediteur_vvvo }}</div>
                            <span class="field-title">Telefon: </span>
                            <div>{{ zeitslotBuchung?.spediteur_telefon_1 }}</div>
                            <span class="field-title">Mobil: </span>
                            <div>{{ zeitslotBuchung?.spediteur_mobil_1 }}</div>
                            <span class="field-title">Fax: </span>
                            <div>{{ zeitslotBuchung?.spediteur_fax }}</div>
                            <span class="field-title">e-Mail: </span>
                            <div>{{ zeitslotBuchung?.spediteur_email }}</div>
                            <span class="field-title">Adresse:</span>
                            <div>
                                <div>{{ zeitslotBuchung?.spediteur_strasse }}</div>
                                <div>{{ zeitslotBuchung?.spediteur_plz }} {{ zeitslotBuchung?.spediteur_ort }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button
                *ngIf="
                    zeitslotBuchung?.status_id === 242 ||
                    zeitslotBuchung?.status_id === 243 ||
                    zeitslotBuchung?.status_id === 244 ||
                    zeitslotBuchung?.status_id === 245
                "
                class="icon-btn pdf-btn"
                (click)="leseLieferschein()"
            >
                <img class="icon-btn-pdf" src="../../../../assets/pdf.svg" />
                Lieferschein anschauen
            </button>
            <button
                style="margin-left: 24px"
                *ngIf="zeitslotBuchung?.status_id === 244 || zeitslotBuchung?.status_id === 245"
                mat-flat-button
                color="accent"
                (click)="readSchlachtdaten()"
            >
                Schlachtdaten ansehen
            </button>
            <button
                style="margin-left: 24px"
                *ngIf="zeitslotBuchung?.status_id === 245"
                mat-flat-button
                color="accent"
                (click)="readAbrechnung()"
            >
                Abrechnung ansehen
            </button>
        </mat-tab>

        <!--
        <mat-tab label="Lieferschein" *ngIf="zeitslot_buchung.status_schlachthof == 1">
            <div class="container">
                <kiene-lieferschein
                    [form]="'landwirt'"
                    [lieferschein_id]="lieferschein_id"
                    *ngIf="lieferscheinNichtAusgefuellt; else elseBlock"
                ></kiene-lieferschein>
                <ng-template #elseBlock>
                    <b>Der Lieferschein wurde bereits ausgefüllt</b>
                </ng-template>
            </div>
        </mat-tab>
-->
        <!--
        <mat-tab
            label="Standort"
            *ngIf="
                zeitslot_buchung.standort ||
                zeitslot_buchung.status_transport == 1 ||
                zeitslot_buchung.status_transport == 2
            "
        >
            <div class="container">
                <kiene-standort
                    [standort_daten]="zeitslot_buchung.standort"
                    [schlachthof_daten]="schlachthofStandort"
                ></kiene-standort>
            </div>
        </mat-tab>

        <mat-tab label="Zusatzinformationen" *ngIf="zeitslot_buchung.status_schlachthof == 1">
            <div class="container">
                <kiene-pdf-upload [buchung_dateien]="buchung_dateien"></kiene-pdf-upload>
            </div>
        </mat-tab>-->
    </mat-tab-group>
</div>
